export enum GeometryType {
  Point = 'Point',
  LineString = 'LineString',
  Polygon = 'Polygon',
  Circle = 'Circle'
}

export enum LabelType {
  Coordinates = 'Coordinates',
  Length = 'Length',
  Area = 'Area',
  Predefined = 'Predefined',
  Custom = 'Custom'
}

export enum CoordinatesUnit {
  DecimalDegree = 'DD',
  DegreesMinutesSeconds = 'DMS'
}
